import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { PublicTrackingLayoutComponent } from './public-tracking-layout.component';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { RouterModule } from '@angular/router';
import { BoschUiLanguageSelectComponent, BoschUiLinkComponent } from '@intrack/bosch-ui-kit';
import { PublicTrackingHeaderComponent } from './public-tracking-header/public-tracking-header.component';
import { PublicTrackingFooterComponent } from './public-tracking-footer/public-tracking-footer.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MatCardModule,
    MatButtonModule,
    TranslateModule.forChild({}),
    MatToolbarModule,
    IntrackFeatureModule,
    BoschUiLinkComponent,
    BoschUiLanguageSelectComponent,
  ],
  exports: [PublicTrackingLayoutComponent],
  declarations: [
    PublicTrackingLayoutComponent,
    PublicTrackingHeaderComponent,
    PublicTrackingFooterComponent,
    PublicTrackingFooterComponent,
  ],
})
export class PublicTrackingLayoutModule {}
